// import Vue from 'vue';

import store from '../store/store';
import axios from 'axios';

export default {
  getSecrets() {
    const url = store.getters['auth/url'];
    return axios.get(url+`/api/v1/secrets`)
      .then(response => response.data)
      .catch(error => Promise.reject(error.response));
  },
  getSecret(id) {
    const url = store.getters['auth/url'];
    return axios.get(url+`/api/v1/secrets/${id}`)
      .then(response => response.data)
      .catch(error => Promise.reject(error.response));
  },
  getSecretTemplates() {
    const url = store.getters['auth/url'];
    return axios.get(url+`/api/v1/secret-templates`)
      .then(response => response.data)
      .catch(error => Promise.reject(error.response));
  },
  getSecretTemplate(id) {
    const url = store.getters['auth/url'];
    return axios.get(url+`/api/v1/secret-templates/${id}`)
      .then(response => response.data)
      .catch(error => Promise.reject(error.response));
  },
  searchSecrets(params) {
    const url = store.getters['auth/url'];
    return axios.get(url + `/api/v1/secrets`, params)
      .then(response => response.data)
      .catch(error => Promise.reject(error.response));
  },
  postSecret(payload) {
    const url = store.getters['auth/url'];
    return axios.post(url+`/api/v1/secrets`, payload)
      .then(response => response.data)
      .catch(error => Promise.reject(error.response));
  }
};



// WEBPACK FOOTER //
// ./src/services/Secrets.js